import { useRegistrationGiftIndicators } from "@configs/statsig";
import { PropsWithClassName, cn } from "kz-ui-sdk";
import styles from "./GiftBoxIcon.module.css";

interface GiftBoxIconProps extends PropsWithClassName {
  animated?: boolean;
  size?: number;
  width?: number;
  height?: number;
  shadow?: boolean;
}

const GiftBoxIcon = ({ className, animated = true, size = 16, width, height, shadow = false }: GiftBoxIconProps) => {
  const { showGiftBox } = useRegistrationGiftIndicators();

  if (!showGiftBox) return null;

  return (
    <img
      src="/images/icon-gift-box.png"
      alt="Gift box"
      className={cn(
        styles.icon,
        {
          [styles.animated]: animated,
          [styles.shadow]: shadow,
        },
        className,
      )}
      width={width ?? size}
      height={height ?? size}
      aria-label="Gift box icon"
    />
  );
};

export default GiftBoxIcon;
